module.exports = __webpack_public_path__ + "static/img/img_2.0c01eabd.jpg";